import { render, staticRenderFns } from "./RequestSupport.vue?vue&type=template&id=b8368f2e&scoped=true&"
import script from "./RequestSupport.vue?vue&type=script&lang=js&"
export * from "./RequestSupport.vue?vue&type=script&lang=js&"
import style0 from "./RequestSupport.vue?vue&type=style&index=0&id=b8368f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8368f2e",
  null
  
)

export default component.exports